import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { AdministrationService } from '../../../services/administration.service'
import { WMSValidators } from '../../../shared/validators';

@Component({
    selector: 'dialog-edit-user-level',
    templateUrl: 'dialog.edituserlevel.html',
    styleUrls: ['./dialog.edituserlevel.css']
})
export class EditUserLevelDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    editUserLevelform: FormGroup;
    loading: boolean = false;
    errorMessage: string = '';
    userLevel: string = '';
    userLevelId: string = '';
    datasource = [];
    selectedScreenCodeList = [];
    totalCount: number = 0;

    constructor(public dialogRef: MatDialogRef<EditUserLevelDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private administrationService: AdministrationService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.editUserLevelform = new FormGroup({
            userLevelID: new FormControl({ value: this.data.UsrLevelId, disabled: true }),
            userLevel: new FormControl({ value: this.data.UsrLevel, disabled: false }, [Validators.required, Validators.maxLength(20)])
        });

        this.userLevel = this.data.UsrLevel;
        this.loading = true;

        let userLevelDetail = {
            UserLevelId: this.data.UsrLevelId,
            UserLevel: this.data.UsrLevel,
            ScnCodePrivilege: this.data.UsrLevelDetails['ScnCodePrivilege'],
            Entity: ''
        }

        let initEditSub = this.administrationService.getUserLevelScreenCode(userLevelDetail)
            .subscribe(
                (data) => {
                    this.loading = false;
                    if (data.status === 204) {

                    } else if (data.status === 200) {
                        this.datasource = data.body['userLevelScreenCodes'];
                        this.totalCount = this.datasource.length;

                        this.datasource.forEach(element => {
                            if (element['Chk'] === true) {
                                this.selectedScreenCodeList.push(element);
                            }
                        });
                    } else {
                        this.openSnackBar('Error loading user level screen code.', '');
                    }
                },
                (error) => {
                    this.loading = false;
                    this.errorMessage = <any>error;
                    this.openSnackBar(this.errorMessage, '');
                });

        //Adds into array for each subscribe
        this.allSub.push(initEditSub);
    }

    cbOnChange(e, d, index: number) {
        let isExist = this.selectedScreenCodeList.some(a => a['ScreenCode'] === d['ScreenCode']);
        if (e.checked) {
            if (!isExist) {
                this.selectedScreenCodeList.push(d);
            }
        } else if (!e.checked) {
            if (isExist) {
                let index = this.selectedScreenCodeList.findIndex(x => x['ScreenCode'] === d['ScreenCode']);
                if (index !== -1) {
                    this.selectedScreenCodeList.splice(index, 1);
                }
            }
        }
    }

    onSave() {
        let cfm = confirm("Are you sure you want to save the changes?");

        if (cfm) {
            this.loading = true;
            this.data.UsrLevelDetails['ScnCodePrivilege'] = '';
            this.selectedScreenCodeList.forEach(element => {
                if (element['Chk'] === true) {
                    this.data.UsrLevelDetails['ScnCodePrivilege'] += element['ScreenCode'] + ',';
                }
            });

            let userLevelDetail = {
                UserLevelId: this.data.UsrLevelId,
                UserLevel: this.editUserLevelform.get('userLevel')!.value,
                ScnCodePrivilege: this.data.UsrLevelDetails['ScnCodePrivilege'],
                Entity: ''
            }

            let save_sub = this.administrationService.updateUserLevelDetails(userLevelDetail)
                .subscribe(
                    (data) => {
                        this.loading = false;
                        if (data.status === 204) {
                        } else if (data.status === 200) {
                            this.dialogRef.close('Edit successful');
                        } else {
                            this.openSnackBar('Error loading saving user level details.', '');
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(save_sub);
        } else {
            this.loading = false;
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}